import React from 'react';

const CheckMark = (): JSX.Element => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.7325 20.4062C13.3566 20.0017 12.7238 19.9785 12.3193 20.3544C11.9147 20.7304 11.8915 21.3631 12.2675 21.7677L13.7325 20.4062ZM16.6364 25L15.9038 25.6807C16.093 25.8843 16.3584 26 16.6364 26C16.9143 26 17.1797 25.8843 17.3689 25.6807L16.6364 25ZM25.7325 16.6807C26.1085 16.2762 26.0853 15.6434 25.6807 15.2675C25.2762 14.8915 24.6434 14.9147 24.2675 15.3193L25.7325 16.6807ZM12.2675 21.7677L15.9038 25.6807L17.3689 24.3193L13.7325 20.4062L12.2675 21.7677ZM17.3689 25.6807L25.7325 16.6807L24.2675 15.3193L15.9038 24.3193L17.3689 25.6807ZM30 20C30 26.0751 25.0751 31 19 31V33C26.1797 33 32 27.1797 32 20H30ZM19 31C12.9249 31 8 26.0751 8 20H6C6 27.1797 11.8203 33 19 33V31ZM8 20C8 13.9249 12.9249 9 19 9V7C11.8203 7 6 12.8203 6 20H8ZM19 9C25.0751 9 30 13.9249 30 20H32C32 12.8203 26.1797 7 19 7V9Z"
                fill="#298512"
            />
        </svg>
    );
};

export default CheckMark;
